var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgECommerceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#EB2F96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39893 9.23047L8.67589 10.3383",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2762 9.23047L11.9993 10.3383",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26038 12.5539H15.3226L16.4304 7.01465H5.35194C5.27093 7.01495 5.19096 7.03301 5.11769 7.06757C5.04441 7.10213 4.97961 7.15234 4.92785 7.21467C4.87608 7.27699 4.83862 7.34991 4.81811 7.42829C4.79759 7.50667 4.79451 7.58859 4.8091 7.66828L5.71753 12.0997C5.73872 12.2278 5.80515 12.3441 5.90475 12.4275C6.00435 12.5108 6.13052 12.5557 6.26038 12.5539V12.5539Z",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4307 7.01454L16.896 5.24197C16.9215 5.11685 16.9895 5.0044 17.0884 4.92365C17.1873 4.8429 17.3111 4.7988 17.4388 4.79883H19.2003",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3228 12.5537L14.8575 14.8802C14.832 15.0053 14.764 15.1178 14.6651 15.1985C14.5661 15.2793 14.4424 15.3234 14.3147 15.3234H7.56787",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1218 19.2006C8.42772 19.2006 8.67572 18.9526 8.67572 18.6467C8.67572 18.3408 8.42772 18.0928 8.1218 18.0928C7.81587 18.0928 7.56787 18.3408 7.56787 18.6467C7.56787 18.9526 7.81587 19.2006 8.1218 19.2006Z",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6611 19.2006C13.967 19.2006 14.215 18.9526 14.215 18.6467C14.215 18.3408 13.967 18.0928 13.6611 18.0928C13.3552 18.0928 13.1072 18.3408 13.1072 18.6467C13.1072 18.9526 13.3552 19.2006 13.6611 19.2006Z",
    stroke: "white",
    strokeWidth: 1.10785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerceIcon);
export default __webpack_public_path__ + "static/media/e_commerce_icon.5d168879637af15ae002cdfbe921e665.svg";
export { ForwardRef as ReactComponent };